export default __webpack_public_path__ + "static/media/load.940eca16.gif";